module.exports = "/static/bin/partitions.bin";